import { createTheme } from "@material-ui/core/styles";

import { light } from "./light";
import { dark } from "./dark";

export const lightTheme = createTheme(light);

export const darkTheme = createTheme(dark);
